import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountModel, IAccount } from '../../shared/models';
import { map } from 'rxjs/operators';
import { arrayOfType } from '../../shared/utils/data.utils';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  constructor(private readonly httpClient: HttpClient) {}

  getAccounts(): Observable<IAccount[]> {
    return this.httpClient
      .get<IAccount[]>(`/api/Lhlhapi/GetAllAccountsByUserIdJson`)
      .pipe(map((accounts: IAccount[]) => arrayOfType<IAccount>(accounts, AccountModel)));
  }
}
